module.exports = __webpack_public_path__ + "static/media/anc4ru.6c6acf56.pdf";